import { Extension, Node } from '@tiptap/core'
import { Plugin } from 'prosemirror-state';

export const table = Node.create({
  name: 'table',
  group: 'block',
  content: '(thead|tbody|tfoot|tr|colgroup)*',
  addAttributes() {
    return {
      id: { default: null },
      role: { default: null },
      align: { default: null },
      width: { default: null },
      border: { default: null },
      cellspacing: { default: null },
      cellpadding: { default: null },
      // style: { default: null },
      style: {
        default: null,
        parseHTML: element => {
          const width = element.style.width;
          if (width === '0px') {
            element.style.removeProperty('width');
          }
          return element.style.cssText;
        },
        renderHTML: attributes => {
          if (!attributes.style) return {}
          return { style: attributes.style }
        },
      },
      class: { default: null },
    }
  },
  parseHTML: () => [{ tag: 'table' }],
  renderHTML: ({ HTMLAttributes }) => ['table', HTMLAttributes, 0],
})

export const thead = Node.create({
  name: 'thead',
  content: 'tr*',
  addAttributes: () => ({
    style: { default: null },
    class: { default: null },
  }),
  parseHTML: () => [{ tag: 'thead' }],
  renderHTML: ({ HTMLAttributes }) => ['thead', HTMLAttributes, 0],
})

export const tbody = Node.create({
  name: 'tbody',
  content: 'tr*',
  addAttributes: () => ({
    style: { default: null },
    class: { default: null },
  }),
  parseHTML: () => [{ tag: 'tbody' }],
  renderHTML: ({ HTMLAttributes }) => ['tbody', HTMLAttributes, 0],
})

export const tfoot = Node.create({
  name: 'tfoot',
  content: 'tr*',
  addAttributes: () => ({
    style: { default: null },
    class: { default: null },
  }),
  parseHTML: () => [{ tag: 'tfoot' }],
  renderHTML: ({ HTMLAttributes }) => ['tfoot', HTMLAttributes, 0],
})


export const tr = Node.create({
  name: 'tr',
  content: '(td|th)*',
  addAttributes: () => ({
    style: { default: null },
    class: { default: null },
  }),
  parseHTML: () => [{ tag: 'tr' }],
  renderHTML: ({ HTMLAttributes }) => ['tr', HTMLAttributes, 0],
})

export const th = Node.create({
  name: 'th',
  content: 'block*',
  addAttributes: () => ({
    align: { default: null },
    valign: { default: null },
    style: { default: null },
    class: { default: null },
    colspan: { default: null },
    rowspan: { default: null },
  }),
  parseHTML: () => [{ tag: 'th' }],
  renderHTML: ({ HTMLAttributes }) => ['th', HTMLAttributes, 0],
})

export const td = Node.create({
  name: 'td',
  isolating: true,
  content: 'block*',
  addAttributes: () => ({
    align: { default: null },
    valign: { default: null },
    style: { default: null },
    class: { default: null },
    colspan: { default: null },
    rowspan: { default: null },
    bgcolor: { default: null }
  }),
  parseHTML: () => [{ tag: 'td' }],
  renderHTML: ({ HTMLAttributes }) => ['td', HTMLAttributes, 0],
})

export const col = Node.create({
  name: 'col',
  addAttributes() {
    return {
      width: { default: null },
    }
  },
  parseHTML: () => [{ tag: 'col' }],
  renderHTML: ({ HTMLAttributes }) => ['col', HTMLAttributes],
})

export const colgroup = Node.create({
  name: 'colgroup',
  content: 'col*',
  parseHTML: () => [{ tag: 'colgroup' }],
  renderHTML: ({ HTMLAttributes }) => ['colgroup', HTMLAttributes, 0],
})

export const CleanPastedContent = Extension.create({
  name: 'cleanPastedContent',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          transformPastedHTML(html) {
            const container = document.createElement('div');
            container.innerHTML = html;

            container.querySelectorAll('td').forEach(td => {
              td.querySelectorAll('span').forEach(span => {
                const parent = span.parentNode;
                while (span.firstChild) {
                  parent.insertBefore(span.firstChild, span);
                }
                parent.removeChild(span);
              });
            });

            return container.innerHTML;
          },
        },
      }),
    ];
  },
});


export const TableExtension = Extension.create({
  name: 'TableExtension',

  addExtensions() {
    const extensions = []

    extensions.push(table)

    extensions.push(tr)
    extensions.push(th)
    extensions.push(td)

    extensions.push(thead)
    extensions.push(tbody)
    extensions.push(tfoot)

    extensions.push(col)
    extensions.push(colgroup)
    extensions.push(CleanPastedContent)

    return extensions
  },
})